/**
 * Validates a returnTo URL to prevent open redirect attacks
 * @param returnTo - The URL to validate
 * @returns The validated URL or '/' as fallback
 */
export const validateReturnToUrl = (returnTo: string): string => {
  // Allow home page redirect
  if (returnTo === '/') {
    return returnTo;
  }

  // Block protocol-relative URLs (e.g., //evil.com/phishing)
  // These start with '/' but are interpreted as external URLs by browsers
  if (returnTo.startsWith('//')) {
    console.error('Blocked redirect to protocol-relative URL:', returnTo);
    return '/';
  }

  try {
    const url = new URL(returnTo, window.location.origin);
    // Only allow same-origin URLs or relative paths
    if (url.origin === window.location.origin || returnTo.startsWith('/')) {
      return returnTo;
    } else {
      console.error('Blocked redirect to external URL:', returnTo);
      return '/';
    }
  } catch (error) {
    console.error('Invalid returnTo URL:', returnTo, error);
    return '/';
  }
};
